import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    evaluationsList: [],
    isLoading: false,
    monitoringId: null,
  },
  actions,
  mutations,
  getters,
};
